:host {
  display: block;
}

salla-add-product-button[width=wide] {
  width: 100%;
}

